import * as API from '../api';

export const add = (config) => {
    console.log('CONFIG', config);
    return API.addSession(config);
};



// WEBPACK FOOTER //
// ./src/controllers/session.js